module.exports = __webpack_public_path__ + "static/media/pdfFileIcon.d70e7915.svg";